import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { ViewResourceProps } from '.';
import moment from 'moment';
import {
  // WeaDateSwitch,
  WeaNewScroll,
  WeaInputSearch,
  WeaRightMenu,
  WeaDialog,
  WeaLocaleProvider,
  WeaDragChoose
} from 'ecCom';
import { Tooltip, Spin, Button, Icon, Carousel } from 'antd';
import { toJS } from 'mobx';
import List from '../../components/list';
import { getCurrentDate } from '../../apis/resource';
import jQuery from 'jquery';
import { InnerTabCard } from '../../components/card';
import ViewResourceSearch from "./ViewResourceSearch";
import ResourceDateSwitch from "./ResourceDateSwitch";
import ResourceHideListWrap from "./ResourceHideListWrap";
import { getHeight } from '../../components/list/utils';
const getLabel = WeaLocaleProvider.getLabel;

if (WeaLocaleProvider.getUserLanguage() == 7 || WeaLocaleProvider.getUserLanguage() == 9) {
  moment.locale('zh-cn');
} else {
  moment.locale('en');
}

@observer
export default class ViewResouceContainer extends React.Component<ViewResourceProps, any> {

  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      foucsInput: false,
    }
    getCurrentDate({}).then(({ currentDate }) => {
      this.setState({ date: currentDate });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    this.createHeight();
    const { cubeViewResource, Search } = this.props;
    setTimeout(() => {
      if (cubeViewResource.windowTitle != '') {
        document.title = cubeViewResource.windowTitle;
      }
    }, 500);
    Search.isInnerTab = true;
    Search.changeIsFromViewResource();
    document.addEventListener('click', () => {
      cubeViewResource.handleValueChange('showMoreColorType', true, true);
    });
  }

  componentWillReceiveProps() {
    const { cubeViewResource } = this.props;
    this.setState({ date: cubeViewResource.currentdate });
    cubeViewResource.timeType = 'day';
  }

  /*判断拖拽中的每个块是否激活*/
  checkDragActive = (itemProps, dragState) => {
    let { room, itemPosition } = itemProps, { startProps = {} } = dragState, startRoom = startProps.room || {}
    if (startRoom.id && room.id == startRoom.id) {
      let { minRow, minColumn, maxRow, maxColumn } = dragState
      return itemPosition[0] >= minRow && itemPosition[0] <= maxRow && itemPosition[1] >= minColumn && itemPosition[1] <= maxColumn
    }
    return false
  }

  createHeight = () => {
    const { cubeViewResource, Search } = this.props;
    const {panelHeightRatio, isHideSearch, isShowMore, handleValueChange}  = cubeViewResource;
    // 处理高度自适应问题
    let
      container = jQuery('.resource-container', ReactDOM.findDOMNode(this)),
      conHeight = this.props.height ? (this.props.height - 108) : container.height();
    let listHeight;
    let tab = jQuery('.resource-plan-tab', container), tabHeight = tab.height() + 18; // 资源面板内部table高度 + 收缩列表图标高度
    const maxTabHeight = (panelHeightRatio / 100) * jQuery('.coms-mode-viewResource').height() - 108;
    if (cubeViewResource.showMoreVisible) {
      tabHeight = tabHeight + 36;
    }
    if (tabHeight >= maxTabHeight) {
      listHeight = conHeight - maxTabHeight;
      tabHeight = maxTabHeight;
    } else {
      listHeight = conHeight - tabHeight;
    }
    // 处理隐藏列表的情况
    if (isHideSearch && tabHeight > 0 && jQuery('.resource-container>.align-center').length==0) {
      // 列表隐藏，资源面板高度 = 页面容器高度
      tabHeight = conHeight;
      // const noDataHeight = jQuery('.resource-container .resource-list-placeholder')[0]?jQuery('.resource-container .resource-list-placeholder')[0].offsetHeight:0;
      const tabContainerHeight = jQuery('.resource-container .tab-container').height();
      // 资源面板需增加的高度 = 页面容器高度 - 收缩列表图标高度 - “显示更多”按钮高度 - 现在资源面包窗口高度
      const addHeight = tabHeight - 18 - this.hasMoreBtn() - tabContainerHeight
      // addHeight>=0 &&this.expandResourceHeigh('add', (addHeight!=0||addHeight<listHeight)?listHeight:addHeight);
      // 如果需要增加的高度大于0，调用expandResourceHeight方法调整资源面板高度
      addHeight>=0 &&this.expandResourceHeigh('add', addHeight);
    }
    if (isShowMore) {
      this.expandResourceHeigh('reset', 0);
      getHeight(Search);
      // 显示更多可能会触发资源面板窗口扩大，为避免列表出现双滚动条，需要同步调整列表高度
      jQuery(".list-container>div[id^='cube_search']>.ant-spin-nested-loading>.ant-spin-container>div").height(listHeight);
      handleValueChange('isShowMore', false);
    }
    cubeViewResource.updateHeight(conHeight, tabHeight, listHeight);
  }

  /** 当收缩查询列表，资源面板高度需要相应展开 
   * type: 'add':加  'minus':减
  */
  expandResourceHeigh = (type, listHeight) => {
    const noDataHeight = jQuery('.resource-container .resource-list-placeholder')[0]?jQuery('.resource-container .resource-list-placeholder')[0].offsetHeight:0;
    // 资源面板-展示高度
    const tabContainerHeight = jQuery('.resource-container .tab-container').height();
    // 资源面板-实际高度
    const tableHeight = jQuery('.resource-container .resource-plan-tab').height();
    const tableTrArr = jQuery('.resource-container .tab-container .resource-plan-tab>tbody>tr');

    if (type === 'add') {
      const newTabHeight = tabContainerHeight + listHeight - noDataHeight;
      if (newTabHeight < tableHeight || tableTrArr.length==0) {
        jQuery('.resource-container .tab-container').height(newTabHeight);
      } else {
        jQuery('.resource-container .tab-container').height(newTabHeight);
        const expandHeightValue = Math.floor((newTabHeight - tableHeight) / tableTrArr.length);
        for (let i=0; i<tableTrArr.length; i++) {
          const _tr = tableTrArr.eq(i);
          const tr_height = _tr.height();
          _tr.height(tr_height + expandHeightValue);
        }
      }
    } else if (type === 'minus') {
      const newTabHeight = tabContainerHeight - listHeight;
      if (newTabHeight > tableHeight || tableTrArr.length==0) {
        jQuery('.resource-container .tab-container').height(newTabHeight);
      } else {
        jQuery('.resource-container .tab-container').height(newTabHeight);
        const expandHeightValue = Math.ceil(listHeight / tableTrArr.length);
        for (let i=0; i<tableTrArr.length; i++) {
          const _tr = tableTrArr.eq(i);
          const tr_height = _tr.height();
          _tr.height(tr_height - expandHeightValue);
        }
      }
    } else if (type === 'restore') { // 点击显示更多后，重新计算行高前先恢复原高度
      const newTabHeight = tabContainerHeight - listHeight - noDataHeight;
      if (newTabHeight > tableHeight || tableTrArr.length==0) {
      } else {
        const expandHeightValue = Math.floor((newTabHeight - tableHeight) / tableTrArr.length);
        for (let i=0; i<tableTrArr.length; i++) {
          const _tr = tableTrArr.eq(i);
          const tr_height = _tr.height();
          _tr.height(tr_height + expandHeightValue);
        }
      }
    } else if (type === 'reset') { // 当DOM树中更新资源面板后，需重新计算高度
      const newTabHeight = tabContainerHeight - listHeight - noDataHeight;
      if (newTabHeight < tableHeight || tableTrArr.length==0) {
      } else {
        const expandHeightValue = Math.floor((newTabHeight - tableHeight) / tableTrArr.length);
        for (let i=0; i<tableTrArr.length; i++) {
          const _tr = tableTrArr.eq(i);
          const tr_height = _tr.height();
          _tr.height(tr_height + expandHeightValue);
        }
      }
    }
  }

  handleSearchHide = (bool) => {
    const { Search, cubeViewResource } = this.props;
    const { handleValueChange } = cubeViewResource;
    getHeight(Search);
    let listContainerHeight = jQuery('.resource-hide-list-wrap .list-container').height();
    if (bool) {
      if (listContainerHeight) {
        handleValueChange('isHideSearch', bool);
        handleValueChange('listContainerHeight', listContainerHeight);
        this.expandResourceHeigh('add', listContainerHeight)
      }
    } else {
      const { listContainerHeight } = cubeViewResource;
      handleValueChange('isHideSearch', bool);
      if (listContainerHeight) {
        this.expandResourceHeigh('minus', listContainerHeight)
      }
    }
  }

  doRightMenuAction = (key) => {
    const { cubeViewResource } = this.props;
    if (key == 'add') {
      cubeViewResource.onAdd();
      return;
    }
    // 时分秒加上，会导致从周/月视图跳转到日视图时，日期带入的格式问题，导致日期字段保存失败
    // const d = new Date();
    // cubeViewResource.currentdate = cubeViewResource.currentdate.split(' ')[0] + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
    cubeViewResource.currentdate = cubeViewResource.currentdate.split(' ')[0];
    cubeViewResource.timeType = key;
    this.onChangeWeaDateSwitch(key, cubeViewResource.currentdate, null);
  }

  /*周月日组件切换回调 */
  /**
   * 说明：若日,传点前的日期，且给值movedate，若年或月则传点击后的日期，且movedate不给值
   */
  onChangeWeaDateSwitch = (type, date, range) => {
    const { cubeViewResource } = this.props;
    const { timeType } = cubeViewResource;
    type != timeType && cubeViewResource.updateTimeType(type);
    cubeViewResource.resourceId = '';
    let movedate = '';
    let bywhat = '4';
    if (typeof date != 'string' && date._d && date._i) {
      if (typeof date._d == 'string') {
        date._d = new Date(date._d);
      }
      if (typeof date._i == 'string') {
        date._i = new Date(date._i);
      }
      if (date._d.getTime() != date._i.getTime() && type == 'day') {//说明点击箭头切换日期
        if (date._d.getTime() < date._i.getTime()) {
          movedate = '-1';
        } else {
          movedate = '1';
        }
      }
    }
    switch (type) {
      case 'year':
        bywhat = '1';
        break;
      case 'month':
        bywhat = '2';
        break;
      case 'week':
        bywhat = '3';
        break;
      case 'day':
        bywhat = '4';
        break;
    }
    let currentdate;
    if (typeof date == 'string') {
      currentdate = date;
    } else if (typeof date._i == 'string') {
      currentdate = bywhat == '4' ? date._i : date._d;
    } else {
      let rightdate;
      if (date._i && date._d) {
        rightdate = bywhat == '4' ? date._i : date._d;
      } else {
        rightdate = date;
      }
      let m = rightdate.getMonth() + 1 + '';
      let d = rightdate.getDate() + '';
      if (m.length == 1) m = '0' + m;
      if (d.length == 1) d = '0' + d;
      currentdate = rightdate.getFullYear() + '-' + m + '-' + d;
    }
    this.setState({ date: date });
    cubeViewResource.query({ bywhat, movedate, currentdate });
  }

  getTableHeaderInfo = (timeType, date, startHour, endHour) => {
    let blockNum = 0, tableTitle = '', tableHeaders: any = [];
    if (moment.isMoment(date)) date = new Date(date.format('L'));
    let curmoment = moment(date);
    if (timeType == 'day') {
      blockNum = endHour - startHour + 1
      tableTitle = curmoment.format(`M${getLabel(383373, '月')}D${getLabel(383374, '日').replace('-', '')}(ddd)${getLabel(33425, '单位')}:`) + getLabel(383376, '时')
      tableTitle = this.modifyWeekName(tableTitle);
      for (startHour; startHour <= endHour; startHour++)
        tableHeaders.push(startHour);
    } else if (timeType == 'week') {
      const { cubeViewResource } = this.props;
      const { weekstart } = cubeViewResource;
      blockNum = 7;
      if (weekstart==='3') { // weekstart=3, 即取今天开始的七天
        let start = curmoment.day();
        let endmoment = moment(date);
        let end = endmoment.day(start+6);
        let startDate = curmoment.format(`YYYY${getLabel(383372, '年')}MM${getLabel(383373, '月')}DD${getLabel(383374, '日').replace('-', '')}`);
        let endDate = end.format(`${end.format('YYYY')===curmoment.format('YYYY')?'':"YYYY"+getLabel(383372, "年")}MM${getLabel(383373, '月')}DD${getLabel(383374, '日').replace('-', '')}`);
        tableTitle = startDate + '~' + endDate;
        for (var i = start; i < (start + 7); i++) {
          const _curmoment = moment(date);
          let titleTemp = _curmoment.day(i).format(`MM${getLabel(383373, '月')}DD${getLabel(383374, '日').replace('-', '')}(ddd)`);
          titleTemp = this.modifyWeekName(titleTemp);
          tableHeaders.push(titleTemp)
        }
      } else {
        let start = weekstart == '2' ? 1 : 0;
        tableTitle = curmoment.format(`YYYY${getLabel(383372, '年')}ww`) + getLabel(383377, '周')
        for (var i = start; i < (start + 7); i++) {
          let titleTemp = curmoment.day(i).format(`MM${getLabel(383373, '月')}DD${getLabel(383374, '日').replace('-', '')}(ddd)`);
          titleTemp = this.modifyWeekName(titleTemp);
          tableHeaders.push(titleTemp)
        }
      }
    } else {
      blockNum = curmoment.daysInMonth()
      tableTitle = curmoment.format(`YYYY${getLabel(383372, '年')}MM${getLabel(383373, '月').replace('-', '')}`) + `(${blockNum}${getLabel(383378, '天')})`
      for (var i = 1; i <= blockNum; i++)
        tableHeaders.push(i);
    }
    return { blockNum: blockNum, tableTitle: tableTitle, tableHeaders: tableHeaders }
  }

  /*周显示多语言修正 ，moment打包后中文失效*/
  modifyWeekName = (name) => {
    try {
      if (WeaLocaleProvider.getUserLanguage() == 7 || WeaLocaleProvider.getUserLanguage() == 9) {
        name = name.replace("Sun", "周日");
        name = name.replace("Mon", "周一");
        name = name.replace("Tue", "周二");
        name = name.replace("Wed", "周三");
        name = name.replace("Thu", "周四");
        name = name.replace("Fri", "周五");
        name = name.replace("Sat", "周六");
      }
    } catch (Exception) {
    }
    return name;
  }

  /*创建面板使用情况的每一行得td*/
  createTdList = (resource, blockNum, rowNum) => {
    const { cubeViewResource } = this.props;
    const { timeType, duration, useMap, weekstart, resourceParams } = cubeViewResource;
    let tdList: any = [];
    let useArray = useMap[resource.id];
    // 创建冲突的、带有提示的单元格
    let createTooltipTd = function (obj, otherProps = {}, width?) {
      let { content, bgcolor, fontcolor, title, tipsinfo } = obj;
      let style: any = { backgroundColor: bgcolor || '#AFDC9E', color: fontcolor || '#000', textAlign: 'center' };
      let td = (
        <Tooltip ecId={`${this && this.props && this.props.ecId || ''}_Tooltip@bd44dc`} title={createTitle(toJS(tipsinfo),toJS(title))} placement="bottomRight">
          <td style={width && { width: width }} {...{ conflict: true }} {...otherProps}>
            <div style={{ ...style, width: '100%', height: '100%' }}>
              <div className="resource-td-modal" />
              {content > 1 && content}</div>
          </td>
        </Tooltip>
      );
      return td;
    };
    if (timeType == 'week' || timeType == 'month') {
      for (let i = 0; i < blockNum; i++) {
        tdList.push(<td>
          <div className="resource-td-modal " />
        </td>);
      }
      if (!useArray || useArray.length == 0) {
        return tdList;
      }
      useArray.forEach((obj) => {
        let objDate = moment(obj.date);
        let tdIdx = timeType == 'week' ? objDate.day() : objDate.date() - 1;
        if (timeType == 'week' && weekstart == '2') {//周一为开始
          tdIdx = tdIdx == 0 ? 6 : tdIdx - 1;
        } else if (timeType == 'week' && weekstart == '3') { // 当前日开始七天
          tdIdx = tdIdx - ( resourceParams['currentdate'] ? moment(resourceParams['currentdate']).day() : 0 );
          if (tdIdx < 0) tdIdx += 7
        }
        if (tdIdx < 0 || tdIdx >= blockNum) return;
        if (timeType == 'month') {//不是当前月的数据过滤掉，避免覆盖数据
          let { date } = this.state;
          if (moment.isMoment(date)) date = new Date(date.format('L'));
          let curmoment = moment(date);
          if (curmoment.year() != objDate.year() || curmoment.month() != objDate.month()) return;
        }
        tdList[tdIdx] = createTooltipTd(obj);
      });
      return tdList;
    } else {
      return this.createTdListInDay(duration, useArray, resource, createTooltipTd, rowNum, tdList);
    }

  }

  /**
   * 暂只针对 周
   * 创建面板使用情况的每一行得td -- 详细信息
   **/
  createDetailTdList = (resource, blockNum, rowNum) => {
    const { cubeViewResource } = this.props;
    const { timeType, duration, useMap, weekstart, resourceParams, onWeekChoose } = cubeViewResource;
    let tdList: any = [];
    let useArray = useMap[resource.id];
    // 创建冲突的、带有提示的单元格
    let createTooltipTd = function (obj, otherProps = {}, width?) {
      let { tdContent/*, bgcolor, fontcolor*/, title, tipsinfo } = obj;
      // let style: any = { backgroundColor: bgcolor || '#AFDC9E', color: fontcolor || '#000', textAlign: 'center' };
      let td = (
        <Tooltip ecId={`${this && this.props && this.props.ecId || ''}_Tooltip@bd44dc`} title={createTitle(toJS(tipsinfo),toJS(title))} placement="bottomRight">
          <td style={width && { width: width }} {...{ conflict: true }} {...otherProps}>
            <div style={{ /*...style,*/ width: '100%', height: '100%', position: 'relative' }}>
              <div className="resource-td-modal" />
              <div className="resource-td-div">
                <span className="resource-td-add" onClick={()=>onWeekChoose(otherProps)}><Icon type="plus" /></span>
              </div>
              {
                tdContent&&tdContent.length>0&&tdContent.map(item => {
                  return (
                    <ul>
                      <span style={{paddingLeft:3}} dangerouslySetInnerHTML={{ __html:item.resourcedetailsshow}} />
                    </ul>
                  )
                })
              }
            </div>
          </td>
        </Tooltip>
      );
      return td;
    };
    if (timeType == 'week' || timeType == 'month') {
      let _otherProps: any[] = [];
      let index = weekstart==='3'?moment(resourceParams['currentdate']).day():(weekstart==='1'?0:1);
      for (let i = index, len = index + blockNum; i < len; i++) {
        const _date = moment(resourceParams['currentdate']).day(i).format("YYYY-MM-DD");
        _otherProps.push({
          itemPosition: [rowNum, i],
          room: resource,
          date: _date
        });
        tdList.push(<td {...{itemPosition: [rowNum, i], room: resource, date: _date}} onClick={()=>onWeekChoose({room: resource, date: _date})}>
          <div className="resource-td-modal " />
          <div className="resource-td-div resource-td-blank" style={{right: "calc(50% - 12px)"}}>
            <span className="resource-td-add"><Icon type="plus" /></span>
          </div>
        </td>);
      }
      if (!useArray || useArray.length == 0) {
        return tdList;
      }
      useArray.forEach((obj) => {
        let objDate = moment(obj.date);
        let tdIdx = timeType == 'week' ? objDate.day() : objDate.date() - 1;
        if (timeType == 'week' && weekstart == '3') { // weekstart=3, 即取今天开始的七天
          tdIdx = tdIdx - ( resourceParams['currentdate'] ? moment(resourceParams['currentdate']).day() : 0 );
          if (tdIdx < 0) tdIdx += 7
        } else if (timeType == 'week' && weekstart == '2') {//周一为开始
          tdIdx = tdIdx == 0 ? 6 : tdIdx - 1;
        }
        if (tdIdx < 0 || tdIdx >= blockNum) return;
        if (timeType == 'month') {//不是当前月的数据过滤掉，避免覆盖数据
          let { date } = this.state;
          if (moment.isMoment(date)) date = new Date(date.format('L'));
          let curmoment = moment(date);
          if (curmoment.year() != objDate.year() || curmoment.month() != objDate.month()) return;
        }
        tdList[tdIdx] = createTooltipTd(obj, _otherProps[tdIdx]);
      });
      return tdList;
    } else {
      return this.createTdListInDay(duration, useArray, resource, createTooltipTd, rowNum, tdList);
    }

  }

  /*创建时间类型为天时的单元格*/
  createTdListInDay(duration, useArray, room, createTooltipTd, rowNum, tdList) {
    const { cubeViewResource } = this.props;
    let { startHour, endHour, dspunit } = cubeViewResource;
    let useBlockMap = {};//已被使用的块，数据结构：小时数:{变色的序号：{背景颜色，字体颜色，内容}，...}
    // let subNum = 1;//每小时会被分成几段
    // 生成已被占用的时间段
    useArray && useArray.forEach((obj) => {
      // 时间处理，确认序号
      if (!obj.time) return;
      let time = obj.time.split(':');
      if (time.length != 2) return;
      let hour = parseInt(time[0]), minute = parseInt(time[1]);
      let idx = duration > 0 ? Math.floor(minute / duration) : 0;
      // 找到该数据对应的存储位置。
      if (!useBlockMap[hour]) useBlockMap[hour] = {};
      let useHour = useBlockMap[hour];
      useHour[idx] = obj;
    });
    let width = (100 / dspunit) + "%";
    /*创建每小时内的分隔块、即第二层td的方法*/
    let createSubTd = (hour, idx, rowNum, colNum) => {
      let startMinute = idx * duration, endMinute = startMinute + duration - 1;
      let startTime = (hour > 9 ? hour : '0' + hour) + ':' + (startMinute > 9 ? startMinute : '0' + startMinute),
        endTime = (hour > 9 ? hour : '0' + hour) + ':' + (endMinute > 9 ? endMinute : '0' + endMinute);
      // 有值则说明已被占用
      if (useBlockMap[hour] && useBlockMap[hour][idx]) {
        return createTooltipTd(useBlockMap[hour][idx], {
          itemPosition: [rowNum, colNum],
          startTime,
          endTime,
          room
        }, width);
      }
      // 空时段
      return (
        <td style={{ width: width }} {...{ itemPosition: [rowNum, colNum] }} {...{ startTime, endTime, room }}>
          <div className="resource-td-modal" />
        </td>
      );
    };

    // 生成第一层td列表
    let colNum = 0;
    for (startHour; startHour <= endHour; startHour++) {
      let subTdList: any = [];
      for (let i = 0; i < dspunit; i++) {
        subTdList.push(createSubTd(startHour, i, rowNum, colNum))
        colNum++;
      }
      let td = (
        <td>
          <table className="resource-subTable">
            <tr>{subTdList}</tr>
          </table>
        </td>
      );
      tdList.push(td);
    }
    return tdList;
  }

  /** 判断是否会显示“显示更多”按钮，如果显示则需在计算中减去高度36px */
  hasMoreBtn = () => {
    const { cubeViewResource } = this.props;
    const { loading, resourcesList } = cubeViewResource;
    const showMoreBtn = !loading && (resourcesList && resourcesList.length > 0) && cubeViewResource.showMoreVisible;
    if (showMoreBtn) { // 显示“显示更多”按钮
      return 36;
    } else { // 不显示“显示更多”按钮
      return 0;
    }
  }

  calculateColorType = () => {
    const { cubeViewResource } = this.props;
    const { showMoreColorType } = cubeViewResource;
    let colorType = toJS(cubeViewResource.colorType);
    const max_ResourcePlanTopWidth = jQuery('.resource-plan-top').width() - 580;
    let colorType_length = colorType.length;
    let colorType_Width = colorType_length * 70;
    let colorType_menu:any[] = [];
    let div_width = colorType_Width;
    let isShowMore:boolean = false;
    
    let colorTypeList: any[] = [];
    while (colorType_length > 0) {
      if (colorType_Width < max_ResourcePlanTopWidth) {
        colorTypeList = colorType.map(item => <span dangerouslySetInnerHTML={{ __html: item }}></span>)
        div_width = colorType.length * 70;
        break;
      } else {
        colorType_menu.push(<div dangerouslySetInnerHTML={{ __html: colorType.pop() }}></div>)
        colorType_Width -= 70;
        colorType_length--;
        isShowMore = true;
        if (colorType_length == 0) {
          div_width = 0;
          break;
        }
      }
    }
    
    if (isShowMore) {
      jQuery('#top-colorType-more .icon-coms').css('visibility','visible');
    } else {
      jQuery('#top-colorType-more .icon-coms').css('visibility','hidden');
    }

    return (
      <div className="resource-top-colorType" style={{width:div_width+50}}>
        {colorTypeList}
        <div id="top-colorType-more" onClick={this.handleColorTypeClick}>
          <i className={showMoreColorType?'icon-coms icon-coms-up2':'icon-coms icon-coms-down2'} />
          <span id="top-colorType-list" className={showMoreColorType?'showMore':''}>{colorType_menu}</span>
        </div>
      </div>
    )
  }

  handleColorTypeClick = (e) => {
    const { cubeViewResource } = this.props;
    const { handleValueChange, showMoreColorType } = cubeViewResource;
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
    handleValueChange('showMoreColorType', showMoreColorType, true);
  }

  getTitleHTML = (title, imgs, index) => {
    let tipArr:any[] = []
    tipArr.push(<div>
      {
        imgs && imgs.length > 0 && (
          <Carousel ecId={`${this && this.props && this.props.ecId || ''}_Carousel@x6ae07@${index}`} className="resource-carousel">
            { imgs instanceof Array && imgs.map(res => <span dangerouslySetInnerHTML={{ __html: res }}/>) }
          </Carousel>
        )
      }
      <div dangerouslySetInnerHTML={{ __html: title }} />
    </div>)
    return <div style={{width: 210}}>{tipArr}</div>
  }

  render() {
    const { Search, cubeViewResource } = this.props;
    const { loading, resourcesList, timeType, card, createUrl, weekstart, opendetailshow, isHideSearch } = cubeViewResource;
    const { resourceId } = cubeViewResource;
    // 列表中使用的数据
    let { date } = this.state
    let { startHour, endHour } = cubeViewResource;
    let { blockNum, tableTitle, tableHeaders } = this.getTableHeaderInfo(timeType, date, startHour, endHour);
    let tableContent = (
      <table className="resource-plan-tab">
        <tbody>
          {!loading && (resourcesList && resourcesList.length > 0) &&
            resourcesList.map((resource, index) => {
              let tdList = (timeType==='week' && opendetailshow === 1) ? this.createDetailTdList(resource, blockNum, index) : this.createTdList(resource, blockNum, index);
              let tdClass = resourceId == resource.id ? 'resource-name cur' : 'resource-name';
              return (
                <tr className={index == 0 ? 'no-border-top' : ''}>
                  <Tooltip ecId={`${this && this.props && this.props.ecId || ''}_Tooltip@gxaa9r@${index}`} placement="right" title={this.getTitleHTML(resource.title, resource.imgs, index)} >
                    <td onClick={() => {
                      isHideSearch && this.handleSearchHide(false);
                      if (resourceId == '') {
                        cubeViewResource.resourceId = resource.id
                        cubeViewResource.search({
                          ...cubeViewResource.searchParam,
                          datasqlwhere: cubeViewResource.searchParam.datasqlwhere + ' and t1.' + cubeViewResource.resourceFieldName + '=\'' + resource.id + '\''
                        });
                      } else {
                        if (resourceId == resource.id) {
                          cubeViewResource.resourceId = '';
                          cubeViewResource.search(cubeViewResource.searchParam);
                        } else {
                          cubeViewResource.resourceId = resource.id
                          cubeViewResource.search({
                            ...cubeViewResource.searchParam,
                            datasqlwhere: cubeViewResource.searchParam.datasqlwhere + ' and t1.' + cubeViewResource.resourceFieldName + '=\'' + resource.id + '\''
                          });
                        }
                      }
                    }} className={tdClass}>{resource.name}</td></Tooltip>
                  {tdList}
                </tr>
              );
            })
          }
        </tbody>
      </table>
    );
    // 高度控制
    const { tabHeight, spinisload } = this.props.cubeViewResource;
    let tabHeightValue = tabHeight - this.hasMoreBtn() - 18; // 减去 “显示更多”和“收缩列表”按钮高度
    let spinisloadvalue = spinisload;
    let listHeightValue = 360;
    let viewResourceContainerHeight = jQuery('.coms-mode-viewResource').eq(0).height();
    if (viewResourceContainerHeight) {
      const showMoreBtn = !loading && (resourcesList && resourcesList.length > 0) && cubeViewResource.showMoreVisible;
      const isNoData = !loading && (resourcesList && resourcesList.length == 0);
      // containerHeight - padding-top - 资源面板高度 - “显示更多”按钮高度 - “暂无数据”的高度 - "收缩列表"按钮
      listHeightValue = jQuery('.coms-mode-viewResource').eq(0).height() - 108 - ( tabHeightValue>130 ? tabHeightValue : 130 ) - (showMoreBtn?36:0) - (isNoData?52:0) - 18;
    }

    return (
      <div onClick={() => Search.showSlideModal(false, "", "")} className="wea-cube-resource-con f12" style={{ height: '100%' }}>
        <div className="resource-plan-top">
          {/* 资源面板的头部操作按钮 */}
          <div className="resource-plan-top-con line">
            {createUrl &&
              <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@pdz1i3`} onClick={() => { cubeViewResource.onAdd() }} style={{ marginRight: 10 }}>{getLabel(82, '新建')}</Button>
            }
            <ResourceDateSwitch ecId={`${this && this.props && this.props.ecId || ''}_WeaDateSwitch@ob1xrk`} currentType={cubeViewResource.timeType} onChange={this.onChangeWeaDateSwitch}
              currentDay={this.state.date} weekFirstDay={cubeViewResource.weekstart == '2' ? 1 : 0} weekstart={weekstart}/>
            <Tooltip ecId={`${this && this.props && this.props.ecId || ''}_Tooltip@1nnvmk`} placement="bottom" title={getLabel(354, '刷新')}>
              <span className="icon-coms-Refresh" style={{
                cursor: 'pointer', padding: '0 10px', color: '#B2B2B2',
                fontSize: '16px', display: 'inline-block', position: 'absolute', top: '15px'
              }}
                onClick={() => {
                  cubeViewResource.query(cubeViewResource.resourceParams);
                }} />
            </Tooltip>
            {/* 资源面板顶部 颜色图例 */}
            <div className="resource-top-colorType">
              {this.calculateColorType()}
            </div>
          </div>
          {/* 资源面板的头部 */}
          <table className="resource-plan-tab-header">
            <tbody>
              <tr className="no-border-top">
                <th className="first align-center">{getLabel(124947, '资源面板')}</th>
                <th colSpan={blockNum}>{tableTitle || getLabel(383375, '读取中') + '...'}</th>
              </tr>
              {tableHeaders && tableHeaders.length > 0 && (
                <tr>
                  <th className="search">
                    <WeaInputSearch ecId={`${this && this.props && this.props.ecId || ''}_WeaInputSearch@3gcgpk`}
                      value={this.state.roomName}
                      style={{
                        display: 'inline-block',
                        width: cubeViewResource.conditions && cubeViewResource.conditions.length > 0 ? 170 : '100%',
                        borderRight: '1px solid #eaeaea'
                      }}
                      placeholder={getLabel(197, '搜索') + '...'}
                      onFocusChange = {bool => {this.setState({foucsInput: bool})}}
                      onSearchChange={v => {
                        cubeViewResource.resourceParams['content'] = v;
                        // 点击x号刷新页面
                        if(v == '' && !this.state.foucsInput){ 
                          cubeViewResource.query({...cubeViewResource.resourceParams, content: v})
                        }
                      }}
                      onSearch={(v) => {
                        cubeViewResource.query({ ...cubeViewResource.resourceParams, content: v })
                      }}
                    />
                    <ViewResourceSearch ecId={`${this && this.props && this.props.ecId || ''}_ViewResourceSearch@ymawxp`} cubeViewResource={cubeViewResource} Search={Search} />
                  </th>
                  {tableHeaders.map((header) => {
                    return (<th className="header">{header}</th>)
                  })}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="resource-container">
          {loading && <div className="align-center" style={{ marginTop: 120 }}><Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@gqi37q`} /></div>}
          {!loading && (!resourcesList || resourcesList.length == 0) && (

            <div className="resource-list-placeholder">
              <i className="anticon anticon-frown" style={{ marginRight: 4 }} />
              {getLabel(83553, '暂无数据')}
            </div>
          )}
          <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@khkq5c`} tip="" spinning={spinisloadvalue}>
            <div className="tab-container" style={{ height: tabHeightValue+1, minHeight: '130px' }}>
              <WeaRightMenu ecId={`${this && this.props && this.props.ecId || ''}_WeaRightMenu@w3dfud`}
                datas={cubeViewResource.rightMenus}
                onClick={this.doRightMenuAction}
                collectParams={{
                  "favname": getLabel(124947, '资源面板'),
                  "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                  "favouritetype": 5,
                  "importantlevel": 1
                }}
              >
                <WeaNewScroll ecId={`${this && this.props && this.props.ecId || ''}_WeaNewScroll@tvmp7f`} height="100%" ref="tabScroll" style={{}}>
                  {/* 资源面板使用情况的内容 */}
                  {timeType == 'day' && createUrl && createUrl != '' ? (
                    <WeaDragChoose ecId={`${this && this.props && this.props.ecId || ''}_WeaDragChoose@0jh3i9`} ref={ref => cubeViewResource.dragref = ref} activeStyle={{ backgroundColor: '#E1ECFF' }}
                      onSelectEnd={cubeViewResource.dragChooseEnd} checkActive={this.checkDragActive}>
                      {tableContent}
                    </WeaDragChoose>
                  ) : tableContent}
                </WeaNewScroll>
              </WeaRightMenu>
            </div>
          </Spin>
          {!loading && (resourcesList && resourcesList.length > 0) && cubeViewResource.showMoreVisible &&
            <div onClick={() => {cubeViewResource.getMore(this.expandResourceHeigh)}} className="list-more">
              {getLabel('83704', '显示更多')}
            </div>}
          <ResourceHideListWrap loading={loading} handleSearchHide={this.handleSearchHide} isHideSearch={cubeViewResource.isHideSearch}>
            <div className="list-container" style={{ height: listHeightValue+2,'overflowY': 'auto' }}>
              <List ecId={`${this && this.props && this.props.ecId || ''}_List@kv476j`} Search={Search} />
            </div>
          </ResourceHideListWrap>
        </div>
        {
          (cubeViewResource.createUrl.indexOf("/spa/cube/index.jsp#/main/cube/card") > -1) ?
            // (cubeViewResource.visible &&
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@5ymqa4`}
              onCancel={() => { cubeViewResource.visible = false; cubeViewResource.query(cubeViewResource.resourceParams); }}
              title={card.cardTab.title || ' '}
              iconBgcolor={card.iconInfo.iconBg || "#96358a"}
              icon={card.iconInfo.icon || 'icon-coms-ModelingEngine'}
              iconFontColor={card.iconInfo.iconColor || "#fff"}
              visible={cubeViewResource.visible}
              hasScroll
              style={{ width: 1200, height: 700 }}
              buttons={cubeViewResource.quickButtons}
              destroyBodyOnClose={true}
            >
              <div className="coms-mode-docker coms-mode-card mode-card-resource mode-card-dialogshow">
                {cubeViewResource.visible && <InnerTabCard ecId={`${this && this.props && this.props.ecId || ''}_InnerTabCard@zf8mb3`} Card={card} Search={Search} />}
              </div>
            </WeaDialog> 
            : <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@bsoj9r`}
              onCancel={() => cubeViewResource.visible = false}
              url={cubeViewResource.createUrl}
              visible={cubeViewResource.visible}
              hasScroll
              style={{ width: 1200, height: 700 }}
            />
        }
      </div>
    )
  }

}

/*创建面板的提示信息*/
const createTitle = function (tipsinfo, titleList) {
  if (Array.isArray(tipsinfo) && tipsinfo.length > 0) {
    return (
      <div className="wea-resource-titletip">
        {tipsinfo.map((meet, idx) => {
          return (
            <div>
              {meet.tipsinfo?<div dangerouslySetInnerHTML={{ __html: meet.tipsinfo }}/>:titleList[idx].map((tip) => <div dangerouslySetInnerHTML={{ __html: tip }}/>)}
              {idx + 1 < tipsinfo.length && <div className="line" />}
            </div>
          );
        })}
      </div>
    );
  }
  return undefined;
}






// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/view-resource/ViewResourceContainer.tsx